import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { allowedBillQRFiles, appt_type_images, datePickerMinDate } from '../shared/constants';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../animations/route-animation';
import moment from 'moment';
import * as FileSaver from 'file-saver';
import { NavbarComponent } from '../navbar/navbar.component';
import { Timestamp, getCountFromServer, Firestore, collection, collectionData, query, where, collectionChanges, DocumentChange, orderBy, writeBatch, doc, getDocs, deleteDoc, onSnapshot, limit, startAfter, QuerySnapshot, DocumentData, arrayUnion } from '@angular/fire/firestore';
import { MessagingService } from '../messaging.service';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class DashboardComponent implements OnInit {
	appt_type_images = appt_type_images;
	user: any = null;
	getTabColumnClass() {
		let cls = "col-lg-3 col-md-6 col-sm-12 col-xs-12";
		try {
			let count = this.navbar.getSavedViewCount();
			if (!count) {
				cls = "col";
			} else if (count === 1) {
				cls = "col-lg-12 col-md-12 col-sm-12 col-xs-12";
			} else if (count === 2) {
				cls = "col-lg-6 col-md-6 col-sm-12 col-xs-12";
			} else if (count === 3) {
				cls = "col-lg-4 col-md-4 col-sm-12 col-xs-12";
			}
		} catch (error) { }
		return cls;
	}

	constructor(private messagingService: MessagingService, private firestore: Firestore, private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	ngOnInit(): void {
		this.apiService.userData$.subscribe((user) => {
			if (user) {
				this.user = user;
				if (this.user.usertype == "SC") {
					this.getAllData();
					this.caseCountsForDashboard();
				}
			}
		});
	}

	getAllData() {
		this.getAppointmentsByDate();
		this.getMissedAppointments();
		this.getIllnessAppointments();
		this.getHospSurgeryAppointments();
		this.getDisabilityAppointments();
		this.getUpcomingAppointments();
		this.getStarAppointments();
		/* this.getReadyForClosureAppointments(); */
		this.getTeleConsultAppointments();
		this.getInjuryAppointments();
		/* this.getBilledAppointments(); */
		this.getReimbursementAppts();
		this.getIncompleteBilling();
		this.getClosureReportNotSent();
		this.getBillingCheckData();
		this.getReadyToBillData();
		this.getPartiallyBilledData();
		this.getReportDraftsData();
		this.getMedicineSupllyData();
		this.messagingService.login().then(userCredential => {
			this.getUnreadMessages();
			this.getUnreadCallEntries();
		}).catch(error => {
			console.error("Firebase login error", error);
			this.toastr.error("Firebase error", 'Error', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
		});
	}

	unreadMessages: any[] = [];
	msgLoader = false;
	getUnreadMessages() {
		this.msgLoader = true;
		const fiveDaysAgo = new Date();
		fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5);
		const fiveDaysAgoTimestamp = Timestamp.fromDate(fiveDaysAgo);
		const chatCollection = collection(this.firestore, "chat");
		const chatQuery = query(
			chatCollection,
			where('sender_type', '==', "candidate"),
			/* where('is_read', '==', false), */
			where('is_call', '==', false),
			where('msgTime', '>=', fiveDaysAgoTimestamp),
			orderBy('msgTime', 'desc')
		);
		/* onSnapshot(chatQuery, snapshot => {
			this.unreadMessages = snapshot.docs.map(d => ({
				id: d.id,
				time_string: this.formatTimestamp(d.data()['msgTime']),
				validURL: this.validURL(d.data()['message']),
				enc_id: btoa(d.data()['channel']),
				...d.data()
			}));
			console.log(this.unreadMessages);
		}); */
		onSnapshot(chatQuery, snapshot => {
			let unreadMessages = snapshot.docs.map(d => {
				const data = d.data();
				const readBy = data['read_by'] || [];
				return {
					id: d.id,
					time_string: this.formatTimestamp(data['msgTime']),
					validURL: this.validURL(data['message']),
					enc_id: btoa(data['channel']),
					isReadByMe: readBy.includes(this.user.id),
					...data
				};
			}).filter(msg => !msg.isReadByMe);
			this.getUnreadEntryCases(unreadMessages, 'msg');
		}, (error) => {
			console.error("Error fetching unread messages:", error);
			this.msgLoader = false;
		});
	}

	unreadCallEntries: any[] = [];
	callLoader = false;
	getUnreadCallEntries() {
		this.callLoader = true;
		const fiveDaysAgo = new Date();
		fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5);
		const fiveDaysAgoTimestamp = Timestamp.fromDate(fiveDaysAgo);
		const chatCollection = collection(this.firestore, "chat");
		const chatQuery = query(
			chatCollection,
			/* where('sender_type', '==', "candidate"),
			where('is_read', '==', false),
			where('is_call', '==', true),
			where('action', '==', "connect"),
			orderBy('msgTime', 'asc') */

			/* where('sender_type', '==', "candidate"),
			where('is_call', '==', true),
			where('call_status', 'in', ['timeout', 'cancelled']),
			where('msgTime', '>=', fiveDaysAgoTimestamp),
			orderBy('msgTime', 'asc') */

			where('sender_type', '==', "candidate"),
			where('is_call', '==', true),
			/* where('is_read', '==', false), */
			where('call_status', 'in', ['timeout', 'cancelled']),
			where('msgTime', '>=', fiveDaysAgoTimestamp),
			orderBy('msgTime', 'desc')
		);
		/* onSnapshot(chatQuery, snapshot => {
			this.unreadCallEntries = snapshot.docs.map(d => ({
				id: d.id,
				time_string: this.formatTimestamp(d.data()['msgTime']),
				validURL: this.validURL(d.data()['message']),
				enc_id: btoa(d.data()['channel']),
				...d.data()
			}));
			console.log(this.unreadCallEntries)
		}); */
		onSnapshot(chatQuery, snapshot => {
			let unreadCallEntries = snapshot.docs.map(d => {
				const data = d.data();
				const readBy = data['read_by'] || [];
				return {
					id: d.id,
					time_string: this.formatTimestamp(data['msgTime']),
					validURL: this.validURL(data['message']),
					enc_id: btoa(data['channel']),
					isReadByMe: readBy.includes(this.user.id),
					...data
				};
			}).filter(msg => !msg.isReadByMe);
			this.getUnreadEntryCases(unreadCallEntries, "call");
		}, (error) => {
			console.error("Error fetching unread messages:", error);
			this.callLoader = false;
		});
	}

	getUnreadEntryCases(unreadEntries: any[], type: "msg" | "call") {
		if (unreadEntries.length === 0) {
			if (type === "msg") {
				this.unreadMessages = [];
				this.msgLoader = false;
			} else {
				this.unreadCallEntries = [];
				this.callLoader = false;
			}
			return;
		}
		this.apiService.getMultipleCases(unreadEntries.map((c: any) => c.channel)).subscribe({
			next: (data) => {
				for (let i = 0; i < unreadEntries.length; i++) {
					unreadEntries[i].case_id = data[i].case_id;
					unreadEntries[i].f_name = data[i].f_name;
					unreadEntries[i].l_name = data[i].l_name;
				}
				if (type === "msg") {
					this.unreadMessages = unreadEntries;
					this.msgLoader = false;
					console.log("Unread messages for this user:", this.unreadMessages);
				} else {
					this.unreadCallEntries = unreadEntries;
					this.callLoader = false;
					console.log("Unread calls for this user:", this.unreadCallEntries);
				}
			}, error: (error) => {
				if (type === "msg") {
					this.msgLoader = false;
				} else {
					this.callLoader = false;
				}
			}
		});
	}

	async markAllAsRead(unreadRecords: any[]) {
		if (!unreadRecords || unreadRecords.length === 0) {
			return;
		}
		/* Firestore batches have a limit of 500 operations per batch */
		const batch = writeBatch(this.firestore);
		unreadRecords.forEach(msg => {
			const docRef = doc(this.firestore, "chat", msg.id);
			batch.update(docRef, {
				read_by: arrayUnion(this.user.id)
			});
		});
		try {
			await batch.commit();
			console.log("All unread messages marked as read for user:", this.user.id);
			/* Optional: Local clear for instant UI feedback before onSnapshot updates */
			unreadRecords = [];
		} catch (error) {
			console.error("Error marking all messages as read:", error);
		}
	}

	validURL(str: any) {
		if (!str) {
			return false;
		}
		var pattern = new RegExp('^(https?:\\/\\/)?' +
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
			'((\\d{1,3}\\.){3}\\d{1,3}))' +
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
			'(\\?[;&a-z\\d%_.~+=-]*)?' +
			'(\\#[-a-z\\d_]*)?$', 'i');
		return !!pattern.test(str);
	}

	formatTimestamp(ts: any): string {
		if (!ts) {
			return '';
		}
		let date: any;
		if (ts.toDate) {
			date = ts.toDate();
		} else {
			date = ts;
		}
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		return `${year}-${month}-${day} ${hours}:${minutes}`;
	}

	loader0 = false;
	caseCounts: any[] = [];
	caseCountsForDashboard() {
		this.loader0 = true;
		this.caseCounts = [];
		this.apiService.getCaseCountsForDashboard().subscribe({
			next: (data: any) => {
				this.loader0 = false;
				for (const key of Object.keys(data)) {
					let obj: any = {
						count: data[key],
						key: key
					};
					let keyPresent = false;
					if (key == "all_cases_count") {
						obj["label"] = "Total Cases";
						obj["cls"] = "bg-all-cases";
						obj["img"] = "calendar-alt-white.svg";
						obj["queryParams"] = {};
						keyPresent = true;
					} else if (key == "closed_count") {
						obj["label"] = "Closed";
						obj["cls"] = "bg-closed-cases";
						obj["img"] = "lock-white.svg";
						obj["queryParams"] = { "filter": "Closed" };
						keyPresent = true;
					} else if (key == "open_count") {
						obj["label"] = "Open";
						obj["cls"] = "bg-open-cases";
						obj["img"] = "lock-open-white.svg";
						obj["queryParams"] = { "filter": "Open" };
						keyPresent = true;
					} else if (key == "physiotherapy_count") {
						obj["label"] = "Ongoing Physiotherapy";
						obj["cls"] = "bg-physio-cases";
						obj["img"] = "person-walking-with-cane-solid-white.svg";
						obj["queryParams"] = { "filter": "Physiotherapy" };
						keyPresent = true;
					} else if (key == "upcoming_arrival_count") {
						obj["label"] = "Upcoming Arrivals";
						obj["cls"] = "bg-upcoming-arrivals";
						obj["img"] = "plane-arrival-silid-white.svg";
						obj["queryParams"] = { "filter": "UpcomingArrivals" };
						keyPresent = true;
					} else if (key == "not_replied_count") {
						obj["label"] = "Not Replied";
						obj["cls"] = "bg-not-replied";
						obj["img"] = "envelope.svg";
						obj["queryParams"] = { "filter": "NotReplied" };
						keyPresent = true;
					}
					if (keyPresent) {
						this.caseCounts.push(obj);
					}
				}
			}, error: (error) => {
				this.loader0 = false;
				this.caseCounts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader1 = false;
	dateWiseAppts: any[] = [];
	filterToday: any = {
		date: new Date()
	};
	getAppointmentsByDate() {
		let data = {
			flag: "appointment_schedule",
			date: this.apiService.getDateStringFromDate(this.filterToday.date)
		}
		this.loader1 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader1 = false;
				/* let len = data.length;
				for (let i = 0; i < len; i++) {
					data[i].follow_up_date_object = this.apiService.getDateFromDateString(data[i].follow_up_date);
				} */
				this.dateWiseAppts = data;
			}, error: (error) => {
				this.loader1 = false;
				this.dateWiseAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	order_by_2: string = "follow_up_date_object";
	order_type_2: string = "asc";
	sortList2(field: string) {
		if (this.order_by_2 == field) {
			if (this.order_type_2 == "asc") {
				this.order_type_2 = "desc";
			} else {
				this.order_type_2 = "asc";
			}
		} else {
			this.order_by_2 = field;
			this.order_type_2 = "asc";
		}
	}

	getOrderIcon2(field: string) {
		if (this.order_by_2 == field) {
			if (this.order_type_2 == "asc") {
				return "sort-up";
			} else {
				return "sort-down";
			}
		} else {
			return "sort";
		}
	}

	loader2 = false;
	missedAppts: any[] = [];
	getMissedAppointments() {
		let data = {
			flag: "appointment_missed"
		}
		this.loader2 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader2 = false;
				let len = data.length;
				for (let i = 0; i < len; i++) {
					data[i].follow_up_date_object = this.apiService.getDateFromDateString(data[i].follow_up_date);
				}
				this.missedAppts = data;
			}, error: (error) => {
				this.loader2 = false;
				this.missedAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	order_by_1: string = "follow_up_date_object";
	order_type_1: string = "asc";
	sortList1(field: string) {
		if (this.order_by_1 == field) {
			if (this.order_type_1 == "asc") {
				this.order_type_1 = "desc";
			} else {
				this.order_type_1 = "asc";
			}
		} else {
			this.order_by_1 = field;
			this.order_type_1 = "asc";
		}
	}

	getOrderIcon1(field: string) {
		if (this.order_by_1 == field) {
			if (this.order_type_1 == "asc") {
				return "sort-up";
			} else {
				return "sort-down";
			}
		} else {
			return "sort";
		}
	}

	loader3 = false;
	illnessAppts: any[] = [];
	getIllnessAppointments() {
		let data = {
			flag: "illness_more_than_90"
		}
		this.loader3 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader3 = false;
				this.illnessAppts = data;
			}, error: (error) => {
				this.loader3 = false;
				this.illnessAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader4 = false;
	hospSurgAppts: any[] = [];
	getHospSurgeryAppointments() {
		let data = {
			flag: "hospital-surgery"
		}
		this.loader4 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader4 = false;
				this.hospSurgAppts = data;
			}, error: (error) => {
				this.loader4 = false;
				this.hospSurgAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader5 = false;
	disabilityAppts: any[] = [];
	getDisabilityAppointments() {
		let data = {
			flag: "disability"
		}
		this.loader5 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader5 = false;
				this.disabilityAppts = data;
			}, error: (error) => {
				this.loader5 = false;
				this.disabilityAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader6 = false;
	upcomingAppts: any[] = [];
	getUpcomingAppointments() {
		let data = {
			flag: "appointment_upcoming"
		}
		this.loader6 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader6 = false;
				let len = data.length;
				for (let i = 0; i < len; i++) {
					data[i].follow_up_date_object = this.apiService.getDateFromDateString(data[i].follow_up_date);
				}
				this.upcomingAppts = data;
			}, error: (error) => {
				this.loader6 = false;
				this.upcomingAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	order_by_3: string = "follow_up_date_object";
	order_type_3: string = "asc";
	sortList3(field: string) {
		if (this.order_by_3 == field) {
			if (this.order_type_3 == "asc") {
				this.order_type_3 = "desc";
			} else {
				this.order_type_3 = "asc";
			}
		} else {
			this.order_by_3 = field;
			this.order_type_3 = "asc";
		}
	}

	getOrderIcon3(field: string) {
		if (this.order_by_3 == field) {
			if (this.order_type_3 == "asc") {
				return "sort-up";
			} else {
				return "sort-down";
			}
		} else {
			return "sort";
		}
	}

	loader7 = false;
	starAppts: any[] = [];
	getStarAppointments() {
		let data = {
			flag: "star_cases"
		}
		this.loader7 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader7 = false;
				this.starAppts = data;
			}, error: (error) => {
				this.loader7 = false;
				this.starAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	/* loader8 = false;
	markedForClosureAppts: any[] = [];
	getReadyForClosureAppointments() {
		let data = {
			flag: "mark_for_closure"
		}
		this.loader8 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader8 = false;
				this.markedForClosureAppts = data;
			}, error: (error) => {
				this.loader8 = false;
				this.markedForClosureAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	} */

	loader9 = false;
	teleconsultAppts: any[] = [];
	filterTeleCon: any = {
		date: new Date()
	};
	getTeleConsultAppointments() {
		if (!this.filterTeleCon.date) {
			this.teleconsultAppts = [];
			return;
		}
		let data = {
			flag: "teleconsult_appointment_schedule",
			date: this.apiService.getDateStringFromDate(this.filterTeleCon.date)
		}
		this.loader9 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader9 = false;
				this.teleconsultAppts = data;
			}, error: (error) => {
				this.loader9 = false;
				this.teleconsultAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader10 = false;
	injuryAppts: any[] = [];
	getInjuryAppointments() {
		let data = {
			flag: "injury_more_than_180"
		}
		this.loader10 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader10 = false;
				this.injuryAppts = data;
			}, error: (error) => {
				this.loader10 = false;
				this.injuryAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	/* loader12 = false;
	billedAppts: any[] = [];
	getBilledAppointments() {
		let data = {
			flag: "case_open_but_bill_done"
		}
		this.loader12 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader12 = false;
				this.billedAppts = data.map((d) => d.case);
			}, error: (error) => {
				this.loader12 = false;
				this.billedAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	} */

	minDate = datePickerMinDate;
	loader13 = false;
	reimbursementAppts: any[] = [];
	totalReimbursment: any = null;
	getReimbursementAppts() {
		this.loader13 = true;
		this.apiService.followupListDashboard({ flag: "reimbursement" }).subscribe({
			next: (data: any) => {
				this.loader13 = false;
				this.reimbursementAppts = data.cases_list;
				this.totalReimbursment = data.grand_total;
			}, error: (error) => {
				this.loader13 = false;
				this.reimbursementAppts = [];
				this.totalReimbursment = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	pdfLoader: any = null;
	getReimbursementPdf(appt: any) {
		this.pdfLoader = appt.case_id;
		this.apiService.getReimbursementPdf(appt.id).subscribe({
			next: res => {
				let excelData: any = res.body;
				this.pdfLoader = null;
				let blob = new Blob([excelData], { type: "application/pdf" });
				let fileName = appt.full_name + ".pdf";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.pdfLoader = null;
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	allowedBillQRFiles = allowedBillQRFiles;
	qrSaveLoader: any = null;
	qrUploaded(filepath: any, id: any) {
		const payload = {
			id: id,
			qrcode: filepath
		}
		this.qrSaveLoader = id;
		this.apiService.updateCaseDetails(payload).subscribe({
			next: (data: any) => {
				this.qrSaveLoader = null;
				this.getReimbursementAppts();
			}, error: (error) => {
				this.qrSaveLoader = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader14 = false;
	incompleteBilling: any[] = [];
	getIncompleteBilling() {
		let data = {
			flag: "incomplete_bills"
		}
		this.loader14 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader14 = false;
				this.incompleteBilling = data;
			}, error: (error) => {
				this.loader14 = false;
				this.incompleteBilling = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader15 = false;
	closureReportNotSent: any[] = [];
	getClosureReportNotSent() {
		let data = {
			flag: "closure_report_not_sent"
		}
		this.loader15 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader15 = false;
				this.closureReportNotSent = data;
			}, error: (error) => {
				this.loader15 = false;
				this.closureReportNotSent = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader16 = false;
	billingCheckData: any[] = [];
	getBillingCheckData() {
		let data = {
			flag: "billing_check"
		}
		this.loader16 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader16 = false;
				this.billingCheckData = data;
			}, error: (error) => {
				this.loader16 = false;
				this.billingCheckData = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader17 = false;
	readyToBillData: any[] = [];
	getReadyToBillData() {
		let data = {
			flag: "ready_to_bill"
		}
		this.loader17 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader17 = false;
				this.readyToBillData = data;
			}, error: (error) => {
				this.loader17 = false;
				this.readyToBillData = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader18 = false;
	partiallyBilledData: any[] = [];
	getPartiallyBilledData() {
		let data = {
			flag: "partially_billed"
		}
		this.loader18 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader18 = false;
				this.partiallyBilledData = data;
			}, error: (error) => {
				this.loader18 = false;
				this.partiallyBilledData = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader19 = false;
	reportDraftsData: any[] = [];
	getReportDraftsData() {
		let data = {
			flag: "draft_mail"
		}
		this.loader19 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader19 = false;
				this.reportDraftsData = data;
			}, error: (error) => {
				this.loader19 = false;
				this.reportDraftsData = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	loader20 = false;
	medicineSupllyData: any[] = [];
	getMedicineSupllyData() {
		let data = {
			flag: "medicine_supply"
		}
		this.loader20 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader20 = false;
				this.medicineSupllyData = data;
			}, error: (error) => {
				this.loader20 = false;
				this.medicineSupllyData = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}
}
